import styled from 'styled-components'
import Div from '@jarvis.oddle/core/components/Div'
import Flex from '@jarvis.oddle/core/components/Flex'
import { colors, coloredBackground } from '@jarvis.oddle/core/theme/default'

export const Container = styled(Flex).attrs(() => ({
  flexDirection: 'column'
}))`
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
  background-color: ${props => props.theme.colorBackgroundColor || colors.background};
`

export const Header = styled(Div)`
  height: ${props => props.height || coloredBackground.headerHeight};
  margin-bottom: -${coloredBackground.headerHeight};
  background-color: ${props => props.theme.buttonColor || colors.brandPrimary};
`
